import { Theme } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles((theme: Theme) => ({
  reportsContainer: {
    padding: "24px 32px",
  },
  search: {
    marginBottom: "24px",
  },
  searchContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  goToEditSubscriptionButton: {
    borderRadius: "8px",
    borderColor: theme.palette.primary.main,
    borderWidth: "1px !important",
    borderStyle: "solid !important",
    height: "40px",
    width: "40px",
    padding: "8px",
  },
  skeleton: {
    transform: "none",
    width: "100%",
    height: 82,
    marginBottom: "24px",
  },
}));

export default styles;
